export const LOGIN_CODE = 'LOGIN_CODE';
export const SEND_LOGIN_CODE = 'SEND_LOGIN_CODE';
